<h1 class="resource-assign__heading">Assignables By Page</h1>

<div class="resource-assign">

  @for (
    asset of sortedPageAssets; track trackByAssignment($index,
    asset)) {
    <div
      class="resource-item"
      >
      <img
        [src]="getIcon(asset)"
        class="resource-item__icon"
        />
      <h4
        class="resource-item__title"
        [matTooltip]="asset.displayName | removeHTMLTags"
        >
        @if (asset.bookActivityNumber) {
          <span>{{ asset.bookActivityNumber }}: </span>
        }
        {{
        asset.displayName
        | removeHTMLTags
        | truncate: 40
        }}
      </h4>
      <add-to-cart-btn
        class="resource-item__plus-button"
        (plusClick)="selectAsset(asset)"
        [checked]="isAssetSelected(asset)"
      ></add-to-cart-btn>
    </div>
  }
</div>
